/**
 * 叫号模块 请求 api
 */
// 引入工具函数
import req from '@/utils/request';

// 获取叫号列表
export const callNumberListApi = (params) => {
  return req.get('/order/signIn/getCellOrderList', params);
}

// 叫号
export const callNumberApi = (params) => {
    return req.post('/order/signIn/callOrder', params);
  }
//排序
export const adjustSortApi = (params) => {
    return req.post('/order/signIn/sort', params);
  }
//过号
export const overNumberedApi = (params) => {
    return req.post('/order/signIn/overNumbered', params);
  }
//重新呼叫
export const restartCallApi = (params) => {
  return req.post('/order/signIn/restartCall', params);
}